<template>
  <generic-modal :title="$t('document')" ref="generic_modal" size="fullscreen">
    <form>
      <div class="columns">
        <div class="column is-two-fifths">
          <div class="field">
            <generic-dropdown
              :title="$t('addressee')"
              :placeholder="$t('select addressee')"
              :is_multiple="false"
              url="/document-sign/addressee/catalog"
              name_field="name"
              value_field="addressee_id"
              @selected="set_addressee"
              ref="addresee_dropdown"
              :add_new="true"
              @add_new="create_addressee"
            />
          </div>
          <div class="container" v-if="addressee && addressee.addressee_id">
            <div class="title is-6">{{ addressee.name }}</div>
            <div class="subtitle is-6 mb-0">
              <span class="icon">
                <i class="fa fa-at"></i>
              </span>
              {{ addressee.email }}
            </div>
            <div class="subtitle is-6">
              <span class="icon">
                <i class="fa fa-phone"></i>
              </span>
              {{ addressee.phone }}
            </div>
          </div>
        </div>

        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('signing template')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/document-sign/signing-profile/catalog"
              name_field="name"
              value_field="signing_profile_id"
              @selected="set_signing_profile"
              ref="signing_profile_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('profile')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/document-sign/profile/catalog"
              name_field="name"
              value_field="profile_id"
              @selected="set_profile"
              ref="profile_dropdown"
            />
          </div>
        </div>
      </div>
      <!-- <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("send date") }}</label>
            <div class="control">
              <input class="input" type="date" v-model="meta.send_date" />
            </div>
          </div>
        </div>
      </div> -->

      <div class="title is-5">{{ $t("document") }}</div>
      <document ref="document" @error="set_error" />
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
  <addressee-modal ref="addressee_modal" />
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import AddresseeModal from "../../addressee_datatable/addressee_modal/Index.vue";
import Document from "./Document.vue";

export default {
  name: "Document_signatureModal",
  components: { GenericModal, GenericDropdown, AddresseeModal, Document },
  data() {
    return {
      meta: {},
      addressee: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.addressee_id;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/document-sign/document", { uuid: uuid })
        .then((element) => {
          v.meta = element;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      data.settings.pages = v.$refs.document.get_pages();
      v.$root.loader(true);
      if (!v.meta.uuid)
        put("/document-sign/document", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
            v.set_initial_state();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {
            v.$root.loader(false);
          });
      else
        post("/document-sign/document", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
            v.set_initial_state();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {
            v.$root.loader(false);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.addressee = {};
      v.$refs.addresee_dropdown.clear();
      v.$refs.signing_profile_dropdown.clear();
      v.$refs.document.clear();
      v.error = "";
      // v.uuid = "";
    },
    set_addressee(addressee) {
      let v = this;
      if (addressee) {
        v.addressee = addressee;
        v.meta.addressee_id = addressee.addressee_id;
      }
    },
    create_addressee() {
      let v = this;
      v.$refs.addressee_modal.show_modal();
    },
    set_error(error) {
      let v = this;
      v.error = error;
    },
    set_signing_profile(signing_profile) {
      let v = this;
      if (signing_profile)
        v.$refs.document.set_signing_profile(signing_profile);
    },
    set_profile(profile) {
      let v = this;
      if (profile) v.meta.profile_id = profile.profile_id;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
